export default __webpack_public_path__ + "static/media/Record_SelectMicrophone.d8da6329.svg";